import ApplicationForm from './ApplicationForm';

const DriveRegistrationForm = () => {
	return <ApplicationForm />;
};

export default DriveRegistrationForm;
